<template>
  <div>
    <task-detail
      :prize="prize"
    >
      <div slot="title-suffix" class="plv-iar-welfare-lottery__invitation__title-right">
        <span v-if="isCompleted" class="plv-iar-welfare-lottery__invitation__right plv-iar-welfare-lottery__invitation__right--completed">{{ iarTrans('welfareLottery.satisfied') }}</span>
        <template v-else-if="eligible">
          <span class="plv-iar-welfare-lottery__invitation__right">{{ iarTrans('welfareLottery.surplus') }}</span>
          <span v-if="surplusHour" class="plv-iar-welfare-lottery__invitation__item">{{ timeText(surplusHour) }}</span>
          <span class="plv-iar-welfare-lottery__invitation__item">{{ timeText(surplusMinutes) }}</span>
          <span class="plv-iar-welfare-lottery__invitation__item">{{ timeText(surplusSecond) }}</span>
        </template>
      </div>

      <div class="plv-iar-welfare-lottery__invitation__task">
        {{ iarTrans('welfareLottery.watch4') }}<span class="plv-iar-welfare-lottery__invitation__numbers">{{ prize.duration }}</span>{{ iarTrans('welfareLottery.watch3') }}
      </div>
    </task-detail>
    <div class="plv-iar-welfare-lottery__task__btn-group">
      <welfare-lottery-btn
        :disabled="isCompleted || !eligible"
        @click="handleClick"
      >
        {{ iarTrans(btnText) }}
      </welfare-lottery-btn>
    </div>
  </div>
</template>

<script>
import TaskDetail from '../task-detail';
import WelfareLotteryBtn from '../btn.vue';
import mixin from '../mixin';
export default {
  name: 'TaskWatchTime',
  components: {
    TaskDetail,
    WelfareLotteryBtn,
  },
  mixins: [mixin],
  props: {
    prize: {
      type: Object,
      default: () => ({})
    },
    // 已观看分钟数
    watchedTime: {
      type: Number,
      default: 0
    },
    // 是否能进行抽奖任务
    eligible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isCompleted() {
      return this.watchedTime >= this.prize.duration * 60;
    },
    btnText() {
      return this.eligible ?
        this.isCompleted ? 'welfareLottery.participated' : 'welfareLottery.keepWatching' :
        'welfareLottery.notEligible';
    },
    surplusTime() {
      return this.prize.duration * 60 - this.watchedTime;
    },
    surplusHour() {
      return Math.floor(this.surplusTime / 3600);
    },
    surplusMinutes() {
      return Math.floor(this.surplusTime % 3600 / 60);
    },
    surplusSecond() {
      return Math.floor(this.surplusTime % 3600 % 60);
    },
  },
  methods: {
    timeText(num) {
      return num.toString().padStart(2, 0);
    },
    handleClick() {
      if (this.eligible && !this.isCompleted) {
        const obj = {
          type: 'setLottery'
        };
        this.$emit('lottery-callback', obj);
        this.handleClose();
      }
    },
    handleClose() {
      this.$emit('close');
    },
    handleRecord() {
      this.$emit('record');
    },
  }
};
</script>

<style lang="scss">
.plv-iar-welfare-lottery__invitation__title-right {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-left: auto;
  color: #999;
}
.plv-iar-welfare-lottery__invitation__right {
  margin-left: auto;
}

.plv-iar-welfare-lottery__invitation__right + .plv-iar-welfare-lottery__invitation__item {
  margin-left: 4px;
}

.plv-iar-welfare-lottery__invitation__item {
  height: 16px;
  min-width: 16px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: rgba(#FE3F52, 0.2);
  padding: 0 2px;
  font-family: DINProFont;
  color: #FE3F52;
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plv-iar-welfare-lottery__invitation__item + .plv-iar-welfare-lottery__invitation__item {
  margin-left: 10px;

  &::before {
    content: ':';
    position: absolute;
    top: 1px;
    left: -7px;
    line-height: 1;
  }
}
</style>
